<arm-dialog [title]="'Advanced Search'" (onCancel)="onCancel()" (onSubmit)="onSubmit()">
  <div class="search-container">
    <div class="search-column">
      <ac-input-container label="Operative State">
        <ac-select
          [(acModel)]="search.operativeState"
          [items]="search.operStateOptions"
          [allowClear]="true"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="Administrative State">
        <ac-select
          [(acModel)]="search.adminState"
          [items]="search.adminStateSearchOptions"
          [allowClear]="true"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="Node">
        <ac-select
          [(acModel)]="search.nodeId"
          [items]="search.nodesOptions"
          [allowClear]="true"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="Alternative SIP reason">
        <ac-select
                [(acModel)]="search.sipReasonGroupId"
                [items]="search.sipReasonsOptions"
                [allowClear]="true"
                [multiple]="false"
                [bindValue]="'value'"
                [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="VoIP Peer">
        <ac-select
                [(acModel)]="search.voipPeerId"
                [items]="search.voipPeersOptions"
                [allowClear]="true"
                [multiple]="false"
                [bindValue]="'value'"
                [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>
    </div>

    <div class="search-column">
      <ac-input-container label="Quality">
        <ac-select
          [(acModel)]="search.quality"
          [items]="search.qualityOptions"
          [allowClear]="true"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="Calls Quota">
        <ac-select
          [(acModel)]="search.callsQuotaId"
          [items]="search.callsQuotaOptions"
          [allowClear]="true"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="Cac Profile">
        <ac-select
          [(acModel)]="search.cacProfileId"
          [items]="search.cacProfilesOptions"
          [allowClear]="true"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="CAC State">
        <ac-select
                [(acModel)]="search.cacState"
                [items]="search.cacStateOptions"
                [allowClear]="true"
                [multiple]="false"
                [bindValue]="'value'"
                [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

      <ac-input-container label="SecureLogix - call Direction">
        <ac-select
          [(acModel)]="search.callDirection"
          [items]="search.callDirectionOptions"
          [allowClear]="true"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>
    </div>
  </div>
</arm-dialog>
